import {Plugins} from '@packages/systems/wfdl';
import Body from './Body';
import {ElementBodyIcon} from '@packages/systems/spring';

export const plugin = Plugins.PrivilegedPlugin({
  icons: {Body: ElementBodyIcon},
  atoms: {Body},
});
